$(document).ready(function() {
    let ids = [
        "inserts",
        "bras",
        "shapewear",
        "anti-chafing",
        "underwear",
        "mastectomy",
        "covers",
        "tapes",
        "accessories"
    ];

    $('.hdt-marquee-section').each(function(index) {
        if (ids[index]) {
        $(this).attr('id', ids[index]);
        }
    });
});
